module.exports = __webpack_public_path__ + "static/img/AdvertisementBackGroundImg.3861cbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/AdvertisementBackGroundImg.svg
// module id = hcFw
// module chunks = 1